/* @flow */

/* TODO: Исправить flow types
	Добавить аннотиции для cities
*/

import type { TCities } from '../types/city';

import { getCityLinkById } from '../utils';

export function getLinkByCityId(cityId: number, url: string, cities: TCities): string {
	// const checkedCityId = cityId === null ? 78 : cityId;
	const city = getCityLinkById(cityId, cities);
	return `/${city}/${url}`;
}

export function getLinkToLexs(cityId: number, skip: boolean, cities: TCities): string {
	return getLinkByCityId(cityId, 'novostroyki/', cities);
}

export function getLinkToComplex(cityId: number, complexSlug: string, cities: TCities): string {
	return getLinkByCityId(cityId, `novostroyki/${complexSlug}/`, cities);
}

export function getLinkToComplexSection(
	cityId: number,
	complexSlug: string,
	complexSection: 'characteristics' | 'photos' | 'plan' | 'map' | 'rating' | 'expert',
	cities: TCities,
): string {
	return `${getLinkToComplex(cityId, complexSlug, cities)}#${complexSection}`;
}

export function getLinkToComplexReport(cityId: number, complexId: number, cities: TCities): string {
	const linkToReport = `novostroyki/${complexId}/report/`;
	return `${getLinkByCityId(cityId, linkToReport, cities)}`;
}

export function getLinkToComplexReportByUserStatus({
	isUserAnonymous,
	cityLink,
	complexId,
	complexReportLink,
}: {
	isUserAnonymous: boolean,
	cityLink: string,
	complexId: number,
}): string {
	const reportUrl = `/${cityLink}/novostroyki/${complexId}/report/`;
	const loginUrl = `/login/?backUrl=${reportUrl}`;
	// const reportLink = isUserAnonymous ? loginUrl : reportUrl;
	const reportLink = reportUrl;

	return reportLink;
}

export function getLinkToComplexPlannings(
	cityId: number,
	complexSlug: string,
	roomsNumber: ?Array<number>,
	cities: TCities,
): string {
	const rooms = roomsNumber && roomsNumber.length ? `?aparts=${roomsNumber.sort().join('_')}` : '';
	return `${getLinkToComplex(cityId, complexSlug, cities)}${rooms}`;
}

export function getLinkToApart(cityId: number, complexSlug: string, apartmentId: string, cities: TCities): string {
	const apartLink = `apart/${apartmentId}/`;
	return getLinkByCityId(cityId, apartLink, cities);
}

export function getLinkToDeveloper(developerSlug: string): ?string {
	if (typeof developerSlug !== 'string') return null;
	return `/zastroischiki/${developerSlug}/`;
}

export function getLinkToMysteryBuyer(cityId: number, cities: TCities): string {
	const sectionLink = 'expert/tainyi-pokupatel/';
	return getLinkByCityId(cityId, sectionLink, cities);
}

export function getLinkToMysteryBuyerArticle(cityId: number, slug: string, cities: TCities): string {
	const sectionLink = getLinkToMysteryBuyer(cityId, cities);
	return `${sectionLink}${slug}/`;
}

export function getLinkToMysteryTenant(cityId: number, cities: TCities): string {
	const sectionLink = 'expert/tainyi-zhilec/';
	return getLinkByCityId(cityId, sectionLink, cities);
}

export function getLinkToMysteryTenantArticle(cityId: number, slug: string, cities: TCities): string {
	const sectionLink = getLinkToMysteryTenant(cityId, cities);
	return `${sectionLink}${slug}/`;
}

export function getLinkToAnalytics(cityId: number, cities: TCities): string {
	const sectionLink = 'expert/research/';
	return getLinkByCityId(cityId, sectionLink, cities);
}

export function getLinkToAnalyticsArticle(cityId: number, slug: string, cities: TCities): string {
	const sectionLink = getLinkToAnalytics(cityId, cities);
	return `${sectionLink}${slug}/`;
}

export function getLinkToKnowledge(knowledgeType?: 5 | 6 | 7 | 8): string {
	if (knowledgeType === 5) {
		return '/znanie/chto-vybrat/';
	}
	if (knowledgeType === 6) {
		return '/znanie/kak-oformit/';
	}
	if (knowledgeType === 7) {
		return '/znanie/kak-oplatit/';
	}
	if (knowledgeType === 8) {
		return '/znanie/posle-pokupki/';
	}

	return '/znanie/';
}

export function getLinkToKnowledgeArticle(slug: string): string {
	return `${getLinkToKnowledge()}${slug}/`;
}

export function getLinkToJournal(journalType?: 1 | 2 | 3): string {
	if (journalType === 1) {
		return '/journal/living-gorod/';
	}
	if (journalType === 2) {
		return '/journal/living-dvor/';
	}
	if (journalType === 3) {
		return '/journal/living-dom/';
	}

	return '/journal/';
}

export function getLinkToJournalArticle(slug: string): string {
	return `${getLinkToJournal()}${slug}/`;
}

export function getLinkToNews(): string {
	return '/news/';
}

export function getLinkToNewsArticle(slug: string): string {
	return `${getLinkToNews()}${slug}/`;
}

export function changePreviewImageSize(imageLink: string, params: { w: number, h?: number, previewSize?: string }) {
	const { w, h, previewSize } = params;
	const defaultPreviewSize = '400x400';

	return imageLink?.replace(previewSize ? `/${previewSize}/` : `/${defaultPreviewSize}/`, `/${w}x${h || w}/`);
}

/**
 * Изменение ссылки на изображение на подходящее по размеру (с сохранением пропорций), только для ссылок с 0x0
 * @param {string} link - оригинальная ссылка
 * @param {string} size - финальный размер
 * @param {string} currentSize - текущий размер (по умолчанию "0x0")
 * @returns {string} - ссылка на изображение нужного размера
 * */
export const getCroppedImage = (link: string, size: string, currentSize: string = '0x0') =>
	link.indexOf('static.living.ru') > 0 ? link.replace(currentSize, size) : link;
